import { createRouter, createWebHistory } from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

import index from './_index.js'
import source from './source.js'

const routes = [index, source]

const router = createRouter({
  history: createWebHistory(),
  routes
})

//NProgress.configure({ showSpinner: false })
router.beforeEach((to, from, next) => {
  //NProgress.start()
  document.title = to.meta.title || mm.consts.defaultTitle

  const loginName = 'login'
  const isLogin = !!mm.store.state.user.userInfo
  // 已登录
  if (isLogin) {
    if (to.name === loginName) next('/')
    else next()
  } else if (to.meta.needLogin) {
    if (mm.consts.env === 'dev') {
      next({ name: loginName })
    } else {
      location.href = mm.consts.loginUrl
    }
  } else {
    next()
  }
})

router.afterEach(() => {
  //NProgress.done()
  window.closeNProgress()
})

export default router
